export enum EContributionType {
  PENALTY = "PEN",
  CONTRIBUTION = "COM",
}
